/*
**************************** 
홈페이지 구매 전 로그인
*****************************
*/

import axios from "axios";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import FindPass from "./FindPass";
import FindUser from "./FindUser";

import { useContext } from 'react';
import { MyContext } from "../App";

export default function BuyLogin() {
    const { choiceValue, setValue } = useContext(MyContext);

    const navigate = useNavigate();
    const [userLogin, setUserLogin] = useState({ useid: "", password: "" });
    const submit = async function () {

        const login_id = userLogin.useid;
        const password = userLogin.password;

        if (login_id === undefined || login_id === "" || password === undefined || password === "") {
            alert("가입한 아이디/비밀번호를 확인 하세요")
            return;
        }

        const reqSql = "/api/users/auth";
        const params = { login_id, password };
        await axios.post(reqSql, params, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {

            if (res.status === 200) {
                sessionStorage.setItem("state", "true");
                sessionStorage.setItem("userId", res.data.id);
                sessionStorage.setItem("userName", res.data.userName);
                sessionStorage.setItem("toktokSerial", res.data.toktokSerial);

                setValue({ ...choiceValue, userId: res.data.id, amount: choiceValue.amount, prodcutColor: choiceValue.productColor, productAmount: choiceValue.productAmount });
                const buyTarget = sessionStorage.getItem("buyTarget");
                navigate("/" + buyTarget);

                window.closeLogin();
                window.buyProcess();

            } else {
                if (res.status === 204) {
                    alert("로그인 실패");
                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            alert("데이터 가져오는 도중 오류가 발생하였습니다.");
        });
    }
    return (
        <div>
            <div className="modal fade" id="buyAlertlogin" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title fw-bold" id="exampleModalLabel">로그인</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                                const buyTarget = sessionStorage.getItem("buyTarget");
                                window.location.href = "/" + buyTarget;
                            }}></button>
                        </div>
                        <div className="modal-body">
                            <div className="sign-in">
                                <form >
                                    <div className="form-group text-start">
                                        <label htmlFor="userName" className="form-label mt-4">아이디:</label>
                                        <input type="email" className="form-control" placeholder="아이디를 입력해 주세요" name="userName" value={userLogin.useid} onChange={(e) => {
                                            const copyUserData = { ...userLogin };
                                            copyUserData.useid = e.target.value;
                                            setUserLogin(copyUserData);
                                        }}></input>
                                    </div>
                                    <div className="form-group text-start">
                                        <label htmlFor="password" className="form-label mt-4">비밀번호:</label>
                                        <input type="password" className="form-control" placeholder="비밀번호를 입력해 주세요" name="password" value={userLogin.password} onChange={(e) => {
                                            const copyUserData = { ...userLogin };
                                            copyUserData.password = e.target.value;
                                            setUserLogin(copyUserData);
                                        }}></input>
                                    </div>
                                    <div className="form-group mt-4 row p-2">
                                        <button type="button" className="btn btn-lg btn-primary" onClick={() => {
                                            submit();
                                        }}>로그인</button>
                                    </div>
                                </form>
                                                              <div className="row">
                                    <div className="col-6 text-start mt-2">
                                        <Link to={"#"} className="nav-link  m-1 text-muted small fw-bolder pt-2" href="#" data-bs-toggle="modal" data-bs-target="#regist">회원가입</Link>
                                    </div>
                                    <div className="col-3 text-end mt-2 ">
                                        <Link to={"#"} className="nav-link  text-muted small fw-bolder pt-2" href="#" data-bs-toggle="modal" data-bs-target="#findUser">아이디찾기</Link>
                                    </div>
                                    <div className="col-3 text-start mt-2">
                                        <Link to={"#"} className="nav-link text-muted small fw-bolder pt-2" href="#" data-bs-toggle="modal" data-bs-target="#findPass">비밀번호찾기</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FindUser></FindUser>
            <FindPass></FindPass>
        </div>
    )
}